var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceledIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#AA0816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24651 5.54526C6.05284 5.35158 5.73883 5.35158 5.54516 5.54526C5.35148 5.73893 5.35148 6.05294 5.54516 6.24661L6.73744 7.4389C7.04732 7.74878 7.04731 8.2512 6.73743 8.56108L5.54516 9.75339C5.35148 9.94706 5.35148 10.2611 5.54516 10.4547C5.73883 10.6484 6.05284 10.6484 6.24651 10.4547L7.4434 9.25786C7.75363 8.95256 8.25261 8.95409 8.56096 9.26244L9.75329 10.4547C9.94697 10.6484 10.261 10.6484 10.4546 10.4547C10.6483 10.2611 10.6483 9.94706 10.4546 9.75339L9.25851 8.55726C8.95396 8.24862 8.9537 7.75248 9.25773 7.44353L10.4546 6.24661C10.6483 6.05294 10.6483 5.73893 10.4546 5.54526C10.261 5.35158 9.94697 5.35158 9.75329 5.54526L8.56097 6.73757C8.25237 7.04618 7.75278 7.04743 7.44261 6.74135L6.24651 5.54526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledIconRounded);
export default __webpack_public_path__ + "static/media/canceledIconRounded.3b8e940634240a9dcf1c2c9b1f24d4fa.svg";
export { ForwardRef as ReactComponent };